<template>
    <form-dialog150
        ref="timeLineSetup-set"
        title="时间轴设置"
        :data="timeLineSetupInfo"
        width="50%"
        class="form-table-h360"
        labelWidth="200"
        :visible.sync="visibleSync"
        :columns="ColumnList"
        @confirm="save"
    ></form-dialog150>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `TimeLineSetup`,
    components: {},
    props: {
        visible: { type: Boolean, default: () => false },
        userid: { type: Number, default: () => 0 }
    },
    data() {
        return {
            title: `时间轴设置`,
            isShowDemoPassPNG: this.$root.IsShowDemoPassPNG == `1`,
            timeLineSetupInfo: {},
            msg: `closeWindow`,
            dialogFormVisible: true
        }
    },
    created() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
    },
    mounted() {
        this.init()
    },
    computed: {
        ...mapGetters([`ward_auth`, `section_auth`, `currentUser`, `sys_enums`, `active_ward`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`]),
        screenHeight2() {
            return this.screenHeight
        },
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        intervaloption() {
            let r = []
            if (this.isShowDemoPassPNG) {
                r = [
                    { label: `5分钟`, value: 5 },
                    { label: `10分钟`, value: 10 },
                    { label: `20分钟`, value: 20 },
                    { label: `30分钟`, value: 30 },
                    { label: `60分钟`, value: 60 }
                ]
            } else {
                r = [
                    { label: `10分钟`, value: 10 },
                    { label: `20分钟`, value: 20 },
                    { label: `30分钟`, value: 30 },
                    { label: `60分钟`, value: 60 }
                ]
            }

            console.log(`rrrrrrrrrrrrrrrrrrrrr`, r)
            return r
        },
        modeloption() {
            return [
                { label: `横轴模式`, value: 1 },
                { label: `纵轴模式`, value: 2 }
            ]
        },
        ColumnList() {
            return [
                {
                    type: `select`,
                    prop: `interval`,
                    label: `时间轴间隔`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.intervaloption || [],
                    colspan: 24,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `select`,
                    prop: `model`,
                    label: `时间轴模式`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.modeloption || [],
                    colspan: 24,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `time`,
                    prop: `available_start_time`,
                    label: `时间轴可用时间段开始`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `time`,
                    prop: `available_end_time`,
                    label: `时间轴可用时间段结束`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `time`,
                    prop: `first_show_time`,
                    label: `时间轴起始时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `number`,
                    prop: `defaultTimed_event_duration`,
                    label: `默认手术时长(分钟)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    config: { popperAppendToBody: true },
                    default: 60
                }
            ]
        }
    },
    methods: {
        init() {
            let req = this.myaxios.get(`/api/AcisSystem/FullCalendarTimeLineSetup/Get`)
            req.then(data => {
                this.timeLineSetupInfo = data || {}
            }).catch(e => {
                console.log(e)
            })
        },
        save(row) {
            console.log(row)
            this.myaxios.post(`/api/AcisSystem/FullCalendarTimeLineSetup/Put`, row).then(data => {
                this.$message.success(`时间轴设置成功`)
                this.visibleSync = false
                this.$emit(`settimeLineSetupInfo`, data)
            })
            // this.saveOne(row).then(data => {
            //     this.$refs[`close-btn`].close()
            // })
        }
    },
    destroy() {},
    watch: {}
}
</script>

<style scoped lang="less">
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/TimeLineSetup.vue